import { Capability, CONTENT_ACCESS_GRANT_CAPABILITIES } from '@repo/utils/auth';

/** Who opens the admin videos pages: a reader who writes videos, or one who only shares them. */
export const ADMIN_VIDEOS_CAPABILITIES: Capability[] = [
  Capability.VideosEdit,
  ...CONTENT_ACCESS_GRANT_CAPABILITIES,
];
